export default __webpack_public_path__ + "static/media/donaciones_fondo.b2d653f7.png";